import {
  JointContactInformation,
  JointHomeAddress,
  JointIncomeInformation,
  JointPersonalInformation,
  PrimaryBankAccountInformation,
  PrimaryBankCardInformation,
  PrimaryContactInformation,
  PrimaryEmployerInformation,
  PrimaryHomeAddress,
  PrimaryIdentityInformation,
  PrimaryIncomeInformation,
  PrimaryJointApplicantSelection,
  PrimaryPersonalInformation,
  PrimaryPreferenceInformation,
  PrimaryReferenceInformation,
  PrimarySpouseInformation,
  PurchaseInformation,
} from "@/pages/apply/application/sections"

import { defineFormFactory } from "./define-form-factory"

export const PrefilledFormFactory = defineFormFactory("prefilled", {
  steps: ["contact", "additional", "spouse"],
  primarySections: (context) => {
    switch (context.id) {
      case "personal":
      case "address":
      case "contact":
        return [
          PurchaseInformation,
          PrimaryContactInformation,
          PrimaryEmployerInformation,
          PrimaryIncomeInformation,
          PrimaryPersonalInformation,
          PrimaryHomeAddress,
          PrimaryJointApplicantSelection,
        ]
      case "additional":
        return [
          PrimaryIdentityInformation,
          PrimaryReferenceInformation,
          PrimaryBankAccountInformation,
          PrimaryBankCardInformation,
          PrimaryPreferenceInformation,
        ]
      case "spouse":
        return [PrimarySpouseInformation]
      default:
        return []
    }
  },
  jointSteps: ["personal", "address", "contact"],
  jointSections: (context) => {
    switch (context.id) {
      case "personal":
        return [JointPersonalInformation]
      case "address":
        return [JointHomeAddress]
      case "contact":
        return [JointContactInformation, JointIncomeInformation]
      default:
        return []
    }
  },
})
